import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { asyncValidationService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useCheckStraddleIdentifierMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		(straddleIdentifier: string) => {
			return asyncValidationService.checkStraddleIdentifier(
				straddleIdentifier,
			);
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useCheckStraddleIdentifierMutation;
